module.exports = __webpack_public_path__ + "static/media/full-screen-image-3.5cd1e33d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/full-screen-image-3.jpg
// module id = 415
// module chunks = 0